import { render, staticRenderFns } from "./PositionsList.vue?vue&type=template&id=40a07ca2&scoped=true&"
import script from "./PositionsList.vue?vue&type=script&lang=js&"
export * from "./PositionsList.vue?vue&type=script&lang=js&"
import style0 from "./PositionsList.vue?vue&type=style&index=0&id=40a07ca2&lang=scss&scoped=true&"
import style1 from "./PositionsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a07ca2",
  null
  
)

export default component.exports